// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/subscriptions/subscriptionsActions";
import * as uiHelpers from "../SubscriptionsUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import { getRowStyleByStatus } from "../../../_helpers/tableRowStatusColors";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useSubscriptionsUIContext } from "../SubscriptionsUIContext";

export function SubscriptionsTable() {
  // Subscriptions UI Context
  const subscriptionsUIContext = useSubscriptionsUIContext();
  const subscriptionsUIProps = useMemo(() => {
    return {
      ids: subscriptionsUIContext.ids,
      setIds: subscriptionsUIContext.setIds,
      queryParams: subscriptionsUIContext.queryParams,
      setQueryParams: subscriptionsUIContext.setQueryParams,
      openEditSubscriptionPage: subscriptionsUIContext.openEditSubscriptionPage,
      openDeleteSubscriptionDialog: subscriptionsUIContext.openDeleteSubscriptionDialog,
    };
  }, [subscriptionsUIContext]);

  // Getting curret state of subscriptions list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.subscriptions }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  // Subscriptions Redux state

  const rowStyle = (row) => getRowStyleByStatus(row, 'status');
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    subscriptionsUIProps.setIds([])
    // server call by queryParams
    dispatch(actions.fetchSubscriptions(subscriptionsUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscriptionsUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [

    {
      attrs: { title: 'User Name' },
      dataField: "username",
      text: "User Name",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Purchase Date' },
      dataField: "purchase_date",
      text: "Purchase Date",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Expire Date' },
      dataField: "expiry",
      text: "Expire Date",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Type' },
      dataField: "type",
      text: "Type",
    },
    {
      attrs: { title: 'Platform' },
      dataField: "platform",
      text: "Platform",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      attrs: { title: 'Status' },
      dataField: "status",
      text: "Status",
    },

  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: subscriptionsUIProps.queryParams.pageSize,
    page: subscriptionsUIProps.queryParams.pageNumber,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses=" p-4 table-responsive"
                classes="custom-res-table subcription-table table table-head-custom table-head-bg table-vertical-center"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                rowStyle={ rowStyle } 
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  subscriptionsUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: subscriptionsUIProps.ids,
                  setIds: subscriptionsUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
